if (!document.getElementById("cooperative-selector-styles")) {
  const style = document.createElement("style");
  style.id = "cooperative-selector-styles";

  style.textContent = `
    .cooperative-selector__search {
      width: 100%;
      padding: 1.4rem 1.6rem;
      border: 1px solid #d9d9d9;
      border-radius: 8px;
      font-size: 1.6rem;
      color: #1c3844;
      outline: none;
      padding-right: 4.5rem;
    }

    .cooperative-selector__search:focus {
      border-color: #1c3844;
      box-shadow: 0 0 0 1px #1c3844;
    }

    .cooperative-selector__options {
      position: absolute;
      top: calc(100% + 0.8rem);
      left: 0;
      right: 0;
      z-index: 20;
      max-height: 220px;
      overflow-y: auto;
      border: 1px solid #d9d9d9;
      border-radius: 8px;
      text-align: left;
      display: none;
      background: #fff;
    }

    .cooperative-selector__option {
      padding: 1.2rem 1.4rem;
      cursor: pointer;
      color: #1c3844;
      font-size: 1.5rem;
    }

    .cooperative-selector__option:hover,
    .cooperative-selector__option.is-selected {
      background: #f1f5f7;
      font-weight: 700;
    }

    .cooperative-selector__wrapper {
      position: relative;
      width: 100%;
    }

    .cooperative-selector__clear {
      position: absolute;
      right: 1.4rem;
      top: 50%;
      transform: translateY(-50%);
      border: none;
      background: transparent;
      cursor: pointer;
      font-size: 2rem;
      color: #1c3844;
      display: none;
    }
  `;

  document.head.appendChild(style);
}

window.createCooperativeSelector = function ({
  container,
  selected = "",
  placeholder = "Buscar cooperativa...",
  onSelect,
}) {
  if (!container) return;

  if (!Array.isArray(window.COOPERATIVES) || !window.COOPERATIVES.length) return;

  let selectedValue = selected || "";

  container.innerHTML = `
    <div class="cooperative-selector__wrapper">
      <input
        type="text"
        class="cooperative-selector__search"
        placeholder="${placeholder}"
        autocomplete="off"
      >

      <button
        type="button"
        class="cooperative-selector__clear"
        aria-label="Borrar selección"
      >
        ×
      </button>

      <div class="cooperative-selector__options"></div>
    </div>
  `;

  const search = container.querySelector(".cooperative-selector__search");
  const options = container.querySelector(".cooperative-selector__options");
  const clearButton = container.querySelector(".cooperative-selector__clear");

  const selectedItem = window.COOPERATIVES.find((item) => item.value === selectedValue);

  if (selectedItem) {
    search.value = selectedItem.label;
    clearButton.style.display = "block";
  }

  const renderOptions = (term = "") => {
    options.innerHTML = "";

    const normalizedTerm = term.trim().toLowerCase();

    const filtered = window.COOPERATIVES.filter(({ label }) =>
      label.toLowerCase().includes(normalizedTerm)
    );

    filtered.forEach(({ value, label }) => {
      const option = document.createElement("div");
      option.className = "cooperative-selector__option";
      option.textContent = label;
      option.dataset.value = value;

      if (value === selectedValue) {
        option.classList.add("is-selected");
      }

      option.addEventListener("click", () => {
        selectedValue = value;
        search.value = label;
        clearButton.style.display = "block";
        options.style.display = "none";

        if (typeof onSelect === "function") {
          onSelect(value, label);
        }
      });

      options.appendChild(option);
    });

    options.style.display = filtered.length ? "block" : "none";
  };

  search.addEventListener("focus", () => renderOptions(search.value));
  search.addEventListener("input", () => renderOptions(search.value));

  document.addEventListener("click", (event) => {
    if (!container.contains(event.target)) {
      options.style.display = "none";
    }
  });

  clearButton.addEventListener("click", (event) => {
    event.preventDefault();
    event.stopPropagation();

    selectedValue = "";
    search.value = "";
    clearButton.style.display = "none";

    renderOptions();

    if (typeof onSelect === "function") {
      onSelect("", "");
    }

    search.focus();
  });
};